import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class InventoryRemoveAttendeeModal extends React.Component {
    state = {
        submitting: false
    };

    removeAttendees = async () => {
        this.setState({ submitting: true });
        const { eventId, orgId, editedItem } = this.props;
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/inventory/${editedItem._id}`, {
                name: editedItem.name,
                redeemedBy: Object.keys(this.props.checkedAttendees),
                request: 'removeRedeemedBy'
            })
            .then((res) => {
                if (res.data) {
                    this.props.removeRedeemedByAttendees(Object.keys(this.props.checkedAttendees));
                    this.props.toggle();
                }
            });
    };


    render() {
        const { isOpen, toggle } = this.props;
        const { submitting } = this.state;
        const count = Object.keys(this.props.checkedAttendees).length;
        return (

            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Remove Attendee"}
                    bodyHeaderText={<span>You are about to Remove{' '}
                        <b>
                            {count} attendee{count > 1 && 's'}
                        </b>{' '}
                        from this inventory, would you like to continue?</span>}
                    bodyContent={() => {
                        return ('')
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Remove' : 'Removing'}
                    actionButton={() => this.removeAttendees()}
                    actionButtonDisabled={submitting}
                    isDelete={true}


                ></FieldModal>
            </div>

        );
    }
}

export default InventoryRemoveAttendeeModal;
